/*
 * @Author: Auto Generated
 * @FilePath: /mall-fe/src/hooks/useProcureEnumQuery.ts
 * @Description: 采购枚举字典查询 Hook
 *
 * 使用 React Query 在客户端获取采购枚举字典数据
 * 用于订单、支付、结算等业务场景的枚举值映射
 */

import { useQuery } from '@tanstack/react-query';
import { getProcureEnumsData } from 'api/std';
import { queryKeys } from 'libs/react-query';

/**
 * 使用 React Query 获取采购枚举字典数据
 *
 * @param options - 查询选项
 * @param options.enabled - 是否启用查询（默认为 true）
 * @param options.initialData - 初始数据（可选，用于服务端渲染场景）
 *
 * @returns 返回查询结果对象，包含：
 *   - data: 采购枚举字典对象
 *   - isLoading: 是否正在首次加载
 *   - isFetching: 是否正在获取数据（包括后台更新）
 *   - isError: 是否发生错误
 *   - error: 错误信息
 *   - refetch: 手动重新获取数据的函数
 *
 * @example
 * ```tsx
 * function OrderStatus({ status }) {
 *   const { data: enumDict, isLoading } = useProcureEnumQuery();
 *
 *   const statusText = enumDict?.orderStatus?.[status] || '未知状态';
 *
 *   return <span>{statusText}</span>;
 * }
 * ```
 */
export function useProcureEnumQuery(options?: {
  enabled?: boolean;
  initialData?: Record<string, any>;
}) {
  const { enabled = true, initialData } = options || {};

  return useQuery({
    // 查询键，用于缓存和标识查询
    queryKey: queryKeys.procureEnum.list(),

    // 查询函数，返回 Promise
    queryFn: async () => {
      try {
        const res = await getProcureEnumsData({});

        if (res.code === 200 && res.data != null) {
          return res.data;
        }

        // 返回空对象作为默认值
        return {};
      } catch (error) {
        console.error('获取采购枚举字典失败:', error);
        // 返回空对象作为默认值
        return {};
      }
    },

    // 是否启用查询
    enabled,

    // 初始数据（用于服务端渲染场景）
    initialData,

    // 数据在5分钟内被认为是新鲜的
    staleTime: 2 * 60 * 1000,
  });
}
